export default __webpack_public_path__ + "static/media/slider-midios-1.bc12ea2d.jpg";